export default {
  title: '代理賺錢',
  myCommission: '我的佣金',
  teamSize: '團隊人數',
  teamDeposit: '團隊充值',
  teamContribute: '團隊貢獻',
  teamBet: '團隊投注',
  newYesterday: '昨日新增',
  newMonth: '月新增',
  activeMonth: '月活躍',
  teamWinLoss: '團隊輸贏',
  serviceCenter: '服務中心',
  members: '成員管理',
  memberData: '成員數據',
  memberProxyDeposit: '代理代存',
  liveConsume: '直播消費',
  memberSearchPlaceholder: '下級代理 ID',
  memberSearch: '查詢',
  memberColUser: '用戶',
  memberColContrib: '貢獻',
  memberColAction: '操作',
  memberId: 'ID: {id}',
  memberEdit: '編輯成員',
  memberEmpty: '沒有找到成員數據',
  memberEmptyHint: '請核對下級代理 ID 後重新查詢',
  memberNotFound: '未找到該直屬成員',
  memberDataUpdated: '成員數據已更新',
  memberLoadMore: '加載更多',
  memberLoading: '加載中…',
  memberNoMore: '沒有更多了',
  materials: '推廣素材',
  materialsInvitePrefix: '邀請好友加入',
  materialsInviteSub: '你與好友都能輕鬆賺佣金',
  materialsCardTitle: '{brand} 專屬邀請',
  materialsCardDesc: '分享你的專屬鏈接，好友註冊後自動綁定',
  materialsQrHint: '請使用手機瀏覽器掃碼進入',
  materialsCopyLink: '複製鏈接',
  materialsSaveQr: '保存二維碼',
  materialsSaveOk: '二維碼已保存',
  materialsSaveFail: '保存失敗，請長按圖片保存',
  gameRecords: '遊戲記錄',
  gameRecordTime: '時間',
  gameRecordMember: '會員賬號',
  gameRecordMemberPlaceholder: '請輸入會員 ID',
  gameRecordUpdated: '遊戲記錄已按所選條件更新',
  gameRecordBetTotal: '下注金額：',
  gameRecordProfitTotal: '盈虧金額：',
  gameRecordBetCount: '下單注量',
  gameRecordBetAmount: '下單金額',
  gameRecordWinAmount: '中獎金額',
  gameRecordViewDetail: '查看詳情 >',
  gameRecordEmpty: '暫無遊戲記錄',
  gameRecordEmptyHint: '沒有找到該會員的平台記錄',
  gameRecordBackSummary: '返回平臺彙總',
  gameRecordOrdersTitle: '{name} 注單',
  gameRecordBetTime: '下注時間',
  gameRecordBetContent: '下注內容',
  gameRecordOrderStatus: '訂單狀態',
  gameRecordOrderNo: '訂單編號',
  gameRecordSettled: '已結算',
  gameRecordPending: '待結算',
  gameRecordCancelled: '已取消',
  gameRecordLoading: '加載中…',
  gameRecordLoadMore: '加載更多',
  gameRecordNoMore: '沒有更多了',
  withdrawNow: '立即提現',
  incomeWithdraw: '收入提現',
  withdrawRecords: '提現記錄',
  withdrawNotice: '請仔細核對收款信息，轉入他人賬戶將無法追回',
  withdrawableAmount: '可提現金額',
  withdrawingAmount: '提現中金額',
  transferringAmount: '轉入中金額',
  withdrawToAccount: '提現到賬戶',
  withdrawToAccountSub: '轉到外部收款賬戶',
  withdrawToBalance: '轉入賬戶餘額',
  withdrawToBalanceSub: '直接轉入賬戶餘額',
  withdrawAmount: '提現金額',
  withdrawManageAccount: '管理提現賬戶',
  withdrawAll: '全部',
  withdrawArrivalAmount: '可到金額: {amount}',
  withdrawSelectAccount: '請選擇提現賬戶',
  withdrawChangeAccount: '更改',
  withdrawPickTitle: '選擇提現賬戶',
  withdrawAddMethod: '添加提現方式',
  withdrawNoAccount: '暫無提現賬戶',
  withdrawScheduleHint: '每月 1—31 號可提交提現申請，收益將在 1—5 天統一發放。',
  withdrawAmountRequired: '請輸入提現金額',
  withdrawExceed: '提現金額不能超過可提現金額 {amount}',
  withdrawExceedLimit: '提現金額不能超過單筆限額 {amount}',
  withdrawBelowMin: '提現金額不能低於 {amount}',
  withdrawSelectAccountRequired: '請選擇提現賬戶',
  withdrawSubmitted: '提現申請已提交',
  transferSubmitted: '已轉入賬戶餘額',
  transferProcessing: '轉入中',
  withdrawAccounts: '管理提現賬戶',
  waMultiSelect: '多選',
  waDone: '完成',
  waLockLabel: '賬戶已鎖定',
  waLockHint: '開啟多選後可管理此賬戶',
  waDelete: '刪除賬戶',
  waDeleteSuccess: '{name} 賬戶已刪除',
  waAddAccount: '添加賬戶',
  waEmpty: '暫無提現賬戶',
  waEmptyHint: '添加收款賬戶後即可提交提現申請',
  waSheetTitle: '添加收款方式',
  waFormTitle: '添加 {name}',
  waNoticeAccount: '請仔細核對收款賬號，轉入他人賬戶將無法追回',
  waNoticeAddress: '請仔細核對錢包地址，轉入他人地址將無法追回',
  waNoticeBank: '請仔細核對銀行卡信息，轉入他人賬戶將無法追回',
  waNoticeBankCard: '請仔細核對卡號，轉入他人賬號將無法追回',
  waChainType: '鏈類型',
  waNetwork: '主網',
  waCurrency: '貨幣類型',
  waRegion: '開戶地區',
  waRegionPh: '選擇開戶地區',
  waRegionRequired: '請先選擇一個地區開戶',
  waPickRegion: '選擇地區',
  waPickBank: '選擇開戶銀行',
  waBankSearchPh: '請輸入搜索關鍵字',
  waBankAccount: '銀行賬號',
  waBankAccountPh: '請輸入收款賬號',
  waBranch: '開戶網點',
  waBranchPh: '請輸入開戶網點',
  waBankNamePh: '請選擇開戶銀行',
  waRegionCn: '中國',
  waRegionJp: '日本',
  waRegionTw: '臺灣',
  waRegionHk: '香港',
  waRegionMo: '澳門',
  waRegionSg: '新加坡',
  waBankBoc: '中國銀行',
  waBankIcbc: '工商銀行',
  waBankCcb: '建設銀行',
  waBankAbc: '農業銀行',
  waBankBocom: '交通銀行',
  waBankCitic: '中信銀行',
  waBankCmb: '招商銀行',
  waBankSpdb: '浦發銀行',
  waBankCib: '興業銀行',
  waBankCmbc: '民生銀行',
  waBankCeb: '光大銀行',
  waBankHxb: '華夏銀行',
  waBankPingan: '平安銀行',
  waHolder: '真實姓名',
  waHolderPh: '請輸入真實姓名',
  waCardHolder: '持卡人姓名',
  waCardHolderPh: '請輸入持卡人姓名',
  waBankName: '開戶銀行',
  waCardNo: '銀行卡號',
  waCardNoPh: '請輸入銀行卡號',
  waAccount: '收款賬號',
  waAccountPh: '請輸入收款賬號',
  waAddress: '錢包地址',
  waAddressPh: '請輸入錢包地址',
  waUsdtAddressPh: 'USDT({network})錢包地址',
  waPaste: '粘貼',
  waPasteFail: '粘貼失敗，請手動輸入',
  waSubmit: '立即添加',
  waAddSuccess: '{name} 賬戶已添加',
  waFieldRequired: '請輸入{label}',
  waSelectFieldRequired: '請選擇{label}',
  waChOkpay: 'OKpay',
  waChGopay: 'GOpay',
  waChBank: '銀行卡',
  waChUsdt: 'USDT',
  waChBobi: '波幣錢包',
  waChKdou: 'K豆錢包',
  waChWanbi: '萬幣錢包',
  waChJjpay: 'JJPAY',
  waChVippay: 'VIPpay',
  transferAmount: '轉入金額',
  transferRealtime: '實時到賬',
  transferAmountPlaceholder: '可轉入金額 {amount}',
  transferArrivalBalance: '可到賬戶餘額：{amount}',
  transferToAccount: '轉入賬戶',
  transferUnchangeable: '不可更改',
  transferToBalancePre: '轉入到',
  transferToBalanceName: '賬戶餘額',
  transferTagRealtime: '實時到賬',
  transferTagNoFee: '免手續費',
  transferTagNoBind: '無需綁定賬戶',
  transferTagParity: '1:1 等額到賬',
  transferDesc: '轉入賬戶餘額說明：收入直接轉入賬戶餘額，可立即用於遊戲，無需提現審核。',
  transferHelp: '說明',
  transferSubmit: '確認轉入賬戶餘額',
  billRecords: '賬單明細',
  billTabRecharge: '充值',
  billTabWithdraw: '提現',
  billTabRebate: '返水',
  billTabRedpacket: '紅包',
  billTabReward: '獎勵',
  billTypeFilter: '交易類型',
  billChannel: '渠道',
  billSource: '來源',
  billTime: '時間',
  billChannelBank: '銀行卡',
  billChannelCrypto: '數字貨幣',
  billChannelBalance: '賬戶餘額',
  billWithdrawApply: '提現申請',
  billPromoWithdraw: '推廣提現申請',
  billTypeAllRecharge: '全部充值',
  billTypeBankRecharge: '銀行卡充值',
  billTypeCryptoRecharge: '數字貨幣充值',
  billTypeAllWithdraw: '全部提現',
  billTypeWithdrawAccount: '提現到賬戶',
  billTypeTransferBalance: '轉入賬戶餘額',
  billTypeAllRebate: '全部返水',
  billTypeRealtimeRebate: '實時返水',
  billRebateSourceAll: '全部',
  billTypeAllRedpacket: '全部紅包',
  billTypeSendRedpacket: '發送紅包',
  billTypeClaimRedpacket: '領取紅包',
  billTypeAllReward: '全部獎勵',
  billTypeChestReward: '寶箱任務',
  billTypeSignInReward: '簽到獎勵',
  billStatus: {
    received: '已到賬',
    unprocessed: '未處理',
    reviewing: '審核中',
    success: '成功',
    failed: '失敗',
  },
  billEmpty: '暫無賬單記錄',
  billEmptyTitle: '暫無賬單記錄~',
  billEmptyHint: '你的賬單記錄已經被清空，新的交易記錄會顯示在這裡。',
  billFilterEmpty: '暫無賬單記錄',
  billLoading: '加載中…',
  billLoadMore: '加載更多',
  billMore: '更多',
  billDeleteHint: '這樣將會刪除你目前所有的賬單明細',
  billDeleteNoData: '當前列表無數據',
  billDeleteAll: '刪除全部賬單',
  billCancel: '取消',
  billConfirm: '確認',
  billDeleteConfirmTitle: '確認刪除全部賬單？',
  billDeleteConfirmPrefix: '刪除後將',
  billDeleteConfirmEm: '無法恢復',
  billDeleteConfirmSuffix: '，請謹慎操作。',
  billDeleteSuccess: '刪除成功',
  commissionReport: '佣金報表',
  reportTime: '時間',
  reportTo: '至',
  reportTotal: '{period}總佣金 共 {count} 筆',
  reportTotalCustom: '所選日期總佣金 共 {count} 筆',
  reportDirectCommission: '直屬佣金',
  reportIndirectCommission: '非直屬佣金',
  reportGameCommission: '遊戲佣金',
  reportLiveCommission: '直播佣金',
  reportDetails: '佣金明細',
  reportDetailsSub: '查看每一筆返傭記錄',
  reportColNick: '暱稱',
  reportColTime: '返傭時間',
  reportColType: '返傭類型',
  reportColAmount: '返佣金額',
  reportBasisTurnover: '流水返傭',
  reportBasisNgr: '淨輸贏返傭',
  reportBasisRakeback: '返水分成返傭',
  reportSourceDaily: '日結返傭',
  reportSourceAdjustment: '遲到修正',
  reportDepthDirect: '直屬下級',
  reportTypeLottery: '彩票',
  reportTypeGame: '遊戲',
  reportTypeLive: '直播',
  reportEmpty: '暫無佣金記錄',
  reportEmptyHint: '團隊產生有效貢獻後將按結算週期入賬',
  reportDetailEmpty: '暫無佣金明細',
  reportDetailEmptyHint: '所選日期內暫未產生返傭',
  reportPickDate: '選擇日期',
  reportPickStart: '請選擇開始日期',
  reportPickEnd: '請選擇結束日期',
  reportRangeSelected: '日期區間已選擇',
  reportHeaderDate: '{m}月{d}日周{w}',
  reportHeaderDateEn: '{w}, {month} {d}',
  reportMonthTitle: '{y}年{m}月',
  reportMonthTitleEn: '{month} {y}',
  reportPrevMonth: '上一月',
  reportNextMonth: '下一月',
  reportCancel: '取消',
  reportConfirm: '確定',
  commissionPlan: '佣金方案',
  planFilter: '篩選',
  planConfirm: '確認',
  planAll: '全部',
  planAllLabel: '全部方案',
  planSummary: '{name} · {count}',
  planTiers: '{n} 檔',
  planColPlan: '方案',
  planColTrigger: '觸發流水',
  planColCap: '返傭上限',
  planColRatio: '返傭比例',
  planEmpty: '暫無佣金方案',
  bindRelation: '綁定上下級',
  bindSubTitle: '綁定下級',
  bindSubId: '下級 ID',
  bindCode: '綁定碼',
  bindSubIdPlaceholder: '請輸入下級 ID',
  bindCodePlaceholder: '請輸入綁定碼',
  bindSubIdRequired: '請輸入下級 ID',
  bindCodeRequired: '請輸入綁定碼',
  submitting: '提交中…',
  bindConfirm: '確認綁定',
  bindSuccess: '綁定成功',
  bindSuccessDesc: '下級 ID {id} 已成功綁定（綁定碼 {code}）',
  bindViewRelation: '查看上下級',
  bindTipsTitle: '溫馨提示',
  bindTip1: '代理可通過此功能找回綁定未成功的下級會員。',
  bindTip2: '綁定碼可在“上下級 → 我的名片”中獲取，已經綁定後不再顯示。',
  relation: '上下級',
  relationMyCard: '我的名片',
  relationMySuperior: '我的上級',
  relationId: 'ID: {id}',
  relationBindCode: '綁定碼: {code}',
  relationCopyCard: '複製名片',
  relationNoSuperior: '暫無上級',
  exclusiveCs: '專屬客服',
  comingSoon: '功能即將開放',
  teamStatsTruncated: '數據量過大，請查看佣金報表',
}
